@let isVisibleValue = isVisible();

<div class="launcher__wrapper">
  <button
    #trigger
    type="button"
    class="launcher__icon-container"
    showTooltipOnlyOnDesktop
    tooltipPosition="bottom-right"
    [class.launcher__icon-container--active]="isVisibleValue"
    [attr.aria-label]="'header.tooltips.launcher' | translate"
    [attr.aria-expanded]="isVisibleValue"
    [disableTooltip]="isVisibleValue"
    [kdsTooltip]="'header.tooltips.launcher' | translate"
    (click)="toggleLauncher()"
  >
    <i aria-hidden="true" class="launcher__icon fa-solid fa-grid fa--header-texticon"></i>
  </button>

  @if (isVisibleValue) {
    <itc-launcher-content (closeLauncher)="closeAndFocusTrigger()" />
    <itc-launcher-panel />
  }
</div>
